/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/prefer-default-export
export function populatePaymentType(obj, constPayment) {
  obj.forEach((pagamento) => {
    if (constPayment[pagamento.type]) {
      pagamento.props = constPayment[pagamento.type];
    }
  });
}
